import { Box, Grid } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { LineChart } from "@mui/x-charts";
import {
  selectError,
  selectIsLoading,
  selectSingleSensori,
  selectWeatherData,
} from "../../../features/sensori/sensoriSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchWeatherData } from "../../../features/sensori/sensoriThunk";
// import './lineSensori.scss'

const LineGraph = () => {
  const dispatch = useDispatch();
  const singleId = useSelector(selectSingleSensori)
  const weatherData = useSelector(selectWeatherData);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);

  // Fetch the lineGraph data from the store
  const lineGraphData = weatherData?.lineGraph || [];
  console.log("Fetched lineGraph data:", lineGraphData);

  const parsedLineGraphData = useMemo(() => {
    if(singleId.company_id===35 && singleId.sensore_name === 'seafish'){
      return lineGraphData.map((item) => ({
        ...item,
        temperatura: parseFloat(item.temperatura),
        umidita: parseFloat(item.pulizia_acqua?.replace("%", "")), // if needed
        // pressione: Number(item.pression || 0),
        punto_di_rugiada: parseFloat(item.pH_acqua?.replace("°c", "").trim()) || 0,
      }));
    }
    else{
      return lineGraphData.map((item) => ({
        ...item,
        temperatura: parseFloat(item.temperatura),
        umidita: parseFloat(item.umidita?.replace("%", "")), // if needed
        // pressione: Number(item.pression || 0),
        punto_di_rugiada: parseFloat(item.punto_di_rugiada?.replace("°c", "").trim()) || 0,
      }));
    }
   
    
  }, [lineGraphData]);

  useEffect(() => {
    dispatch(fetchWeatherData())
      .then((data) => {
        console.log("Weather data fetched successfully:", data);
      })
      .catch((error) => {
        console.error("Error fetching weather data:", error);
      });
  }, [dispatch]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  // const dataset = [
  //   { time: "13:00", temperatura: 40, umidita: 5, pressione: 20 },
  //   { time: "13:20", temperatura: 42, umidita: 18, pressione: 38 },
  //   { time: "13:40", temperatura: 45, umidita: 30, pressione: 60 },
  //   { time: "14:00", temperatura: 55, umidita: 38, pressione: 70 },
  //   { time: "14:20", temperatura: 65, umidita: 40, pressione: 75 },
  //   { time: "14:40", temperatura: 70, umidita: 42, pressione: 78 },
  //   { time: "15:00", temperatura: 72, umidita: 43, pressione: 79 },
  //   { time: "15:20", temperatura: 78, umidita: 42, pressione: 78 },
  //   { time: "15:40", temperatura: 82, umidita: 38, pressione: 76 },
  //   { time: "16:00", temperatura: 85, umidita: 30, pressione: 70 },
  //   { time: "16:20", temperatura: 80, umidita: 42, pressione: 65 },
  //   { time: "16:40", temperatura: 72, umidita: 48, pressione: 58 },
  // ];

  const temperatureSeries = [
    {
      dataKey: "temperatura",
      color: singleId.company_id===35 && singleId.sensore_name === 'seafish' ? "#3268ac": "#57C700",
      showMark: true,
    },
  ];

  const dewPointSeries = [
    {
      dataKey: "punto_di_rugiada",
      color: singleId.company_id===35 && singleId.sensore_name === 'seafish' ? "#3df8c2" : "#FF9800",
      showMark: true,
    },
  ];
  
  // const vpdSeries = [
  //   {
  //     dataKey: "pressione",
  //     color: "#FF9800", // Choose your own color
  //     showMark: true,
  //   },
  // ];

  const humiditySeries = [
    {
      dataKey: "umidita",
      color: "#90DDEC",
      showMark: true,
    },
  ];

  const series = [
    {
      dataKey: "temperatura",
      color: "#57C700",
      showMark: true,
    },
    {
      dataKey: "umidita",
      color: "#90DDEC",
      showMark: true,
    },
    {
      id: "punto_di_rugiada",
      label: "Punto di Rugiada",
      color: "#FF9800",
      action: "PuntoDiRugiada",
    },
    {
      dataKey: "pressione",
      color: "#225CA6",
      showMark: true,
    },
  ];
  const dataFilter = singleId.company_id===35 && singleId.sensore_name === 'seafish' 
  ? 
  [
    {
      id: "temperatura",
      label: "Temperatura",
      color: "#3268ac",
      action: "Temperatura",
    },
    {
      id: "pH Acqua",
      label: "pH Acqua",
      color: "#3df8c2",
      action: "PuntoDiRugiada",
    },
    {
      id: "Pulizia Acqua",
      label: "Pulizia Acqua (%)",
      color: "#90DDEC",
      action: "Umidita",
    }
  ] 
  :
  [
    {
      id: "temperatura",
      label: "Temperatura",
      color: "#4CAF50",
      action: "Temperatura",
    },
    {
      id: "punto_di_rugiada",
      label: "Punto di Rugiada",
      color: "#FF9800",
      action: "PuntoDiRugiada",
    },
    {
      id: "umidita",
      label: "Umidità",
      color: "#90DDEC",
      action: "Umidita",
    },
    // {
    //   id: "pressione",
    //   label: "Pressione",
    //   color: "#225CA6",
    //   action: "Pressione",
    // },
  ];
  return (
    <>
      {/* <Box display={"flex"} gap={"27px"} alignItems={"center"}>
        <>
          {dataFilter &&
            dataFilter?.map((item) => (
              <Box
                key={item.id}
                display={"flex"}
                gap={"8px"}
                alignItems={"center"}
                style={{
                  color: item.color,
                  cursor: "pointer",
                  textDecoration: "none",
                }}
              >
                <span
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background: item.color,
                    display: "inline-block",
                  }}
                />
                {item.label}
              </Box>
            ))}
        </>
      </Box> */}

      <Box className="graphLineMain">
        <Box className="graphLineMain__inner">
          <Box className="graphLine">
            {/* Metrics Section */}
            <Box className="graphcard__body">
              <Box
                key={dataFilter[0].id}
                display={"flex"}
                gap={"8px"}
                alignItems={"center"}
                style={{
                  color: dataFilter[0].color,
                  cursor: "pointer",
                  textDecoration: "none",
                }}
              >
                <span
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background: dataFilter[0].color,
                    display: "inline-block",
                  }}
                />
                {dataFilter[0].label}
              </Box>

              <Box style={{ display: "flex" }}>
                <LineChart
                  className="MuiChartsAxis-tickLabel"
                  dataset={parsedLineGraphData}
                  margin={{ left: 60, right: 30, top: 30, bottom: 30 }}
                  xAxis={[
                    {
                      dataKey: "time",
                      scaleType: "point",
                      axisLine: { stroke: "transparent" },
                      tick: {
                        length: 0,
                        size: 0,
                      },
                    },
                  ]}
                  yAxis={[
                    {
                      axisLine: { stroke: "transparent" },
                      tickLine: false,
                      ticks: [0, 20, 40, 60, 80, 100],
                      // valueFormatter: (value) => `${value.toLocaleString()}   k`,
                    },
                  ]}
                  grid={{
                    horizontal: true,
                    strokeDasharray: "5 5",
                    strokeWidth: 1,
                    stroke: "#e0e0e0",
                  }}
                  series={temperatureSeries}
                  height={314}
                  sx={{
                    ".MuiLineElement-root": {
                      strokeWidth: 2,
                    },
                    ".MuiMarkElement-root": {
                      stroke: ({ series }) => series?.color,
                      strokeWidth: 2,
                      scale: "1",
                      fill: "#fff",
                    },
                    "& .MuiChartsAxis-line": {
                      display: "none",
                    },
                    "& .MuiChartsGrid-line": {
                      strokeDasharray: "5 5",
                      stroke: "#e0e0e0",
                    },
                    "& .MuiChartsAxis-tick": {
                      display: "none",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="graphLineMain__inner">
          <Box className="graphLine">
            {/* Metrics Section */}
            <Box className="graphcard__body">
              <Box
                key={dataFilter[1].id}
                display={"flex"}
                gap={"8px"}
                alignItems={"center"}
                style={{
                  color: dataFilter[1].color,
                  cursor: "pointer",
                  textDecoration: "none",
                }}
              >
                <span
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background: dataFilter[1].color,
                    display: "inline-block",
                  }}
                />
                {dataFilter[1].label}
              </Box>

              {/* Chart */}
              <Box style={{ display: "flex" }}>
                <LineChart
                  className="MuiChartsAxis-tickLabel"
                  dataset={parsedLineGraphData}
                  margin={{ left: 60, right: 30, top: 30, bottom: 30 }}
                  xAxis={[
                    {
                      dataKey: "time",
                      scaleType: "point",
                      axisLine: { stroke: "transparent" },
                      tick: {
                        length: 0,
                        size: 0,
                      },
                    },
                  ]}
                  yAxis={[
                    {
                      axisLine: { stroke: "transparent" },
                      tickLine: false,
                      ticks: [0, 20, 40, 60, 80, 100],
                      // valueFormatter: (value) => `${value.toLocaleString()}   k`,
                    },
                  ]}
                  grid={{
                    horizontal: true,
                    strokeDasharray: "5 5",
                    strokeWidth: 1,
                    stroke: "#e0e0e0",
                  }}
                  series={dewPointSeries}
                  height={314}
                  sx={{
                    ".MuiLineElement-root": {
                      strokeWidth: 2,
                    },
                    ".MuiMarkElement-root": {
                      stroke: ({ series }) => series?.color,
                      strokeWidth: 2,
                      scale: "1",
                      fill: "#fff",
                    },
                    "& .MuiChartsAxis-line": {
                      display: "none",
                    },
                    "& .MuiChartsGrid-line": {
                      strokeDasharray: "5 5",
                      stroke: "#e0e0e0",
                    },
                    "& .MuiChartsAxis-tick": {
                      display: "none",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="graphLineMain__inner">
          <Box className="graphLine">
            {/* Metrics Section */}
            <Box className="graphcard__body">
              <Box
                key={dataFilter[2].id}
                display={"flex"}
                gap={"8px"}
                alignItems={"center"}
                style={{
                  color: dataFilter[2].color,
                  cursor: "pointer",
                  textDecoration: "none",
                }}
              >
                <span
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background: dataFilter[2].color,
                    display: "inline-block",
                  }}
                />
                {dataFilter[2].label}
              </Box>
              {/* Chart */}
              <Box style={{ display: "flex" }}>
                <LineChart
                  className="MuiChartsAxis-tickLabel"
                  dataset={parsedLineGraphData}
                  margin={{ left: 60, right: 30, top: 30, bottom: 30 }}
                  xAxis={[
                    {
                      dataKey: "time",
                      scaleType: "point",
                      axisLine: { stroke: "transparent" },
                      tick: {
                        length: 0,
                        size: 0,
                      },
                    },
                  ]}
                  yAxis={[
                    {
                      axisLine: { stroke: "transparent" },
                      tickLine: false,
                      ticks: [0, 20, 40, 60, 80, 100],
                      // valueFormatter: (value) => `${value.toLocaleString()}   k`,
                    },
                  ]}
                  grid={{
                    horizontal: true,
                    strokeDasharray: "5 5",
                    strokeWidth: 1,
                    stroke: "#e0e0e0",
                  }}
                  series={humiditySeries}
                  height={314}
                  sx={{
                    ".MuiLineElement-root": {
                      strokeWidth: 2,
                    },
                    ".MuiMarkElement-root": {
                      stroke: ({ series }) => series?.color,
                      strokeWidth: 2,
                      scale: "1",
                      fill: "#fff",
                    },
                    "& .MuiChartsAxis-line": {
                      display: "none",
                    },
                    "& .MuiChartsGrid-line": {
                      strokeDasharray: "5 5",
                      stroke: "#e0e0e0",
                    },
                    "& .MuiChartsAxis-tick": {
                      display: "none",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* <Box className="graphLine">
        <Box className="graphcard__body">
          <Box style={{ display: "flex" }}>
            <LineChart
              className="MuiChartsAxis-tickLabel"
              dataset={lineGraphData}
              margin={{ left: 50, right: 50, top: 30, bottom: 30 }}
              xAxis={[
                {
                  dataKey: "time",
                  scaleType: "point",
                  axisLine: { stroke: "transparent" },
                  tick: {
                    length: 0,
                    size: 0,
                  },
                },
              ]}
              yAxis={[
                {
                  axisLine: { stroke: "transparent" },
                  tickLine: false,
                  ticks: [0, 20, 40, 60, 80, 100],
                  // valueFormatter: (value) => `${value.toLocaleString()}   k`,
                },
              ]}
              grid={{
                horizontal: true,
                strokeDasharray: "5 5",
                strokeWidth: 1,
                stroke: "#e0e0e0",
              }}
              series={series}
              height={314}
              sx={{
                ".MuiLineElement-root": {
                  strokeWidth: 2,
                },
                ".MuiMarkElement-root": {
                  stroke: ({ series }) => series?.color,
                  strokeWidth: 2,
                  scale: "1",
                  fill: "#fff",
                },
                "& .MuiChartsAxis-line": {
                  display: "none",
                },
                "& .MuiChartsGrid-line": {
                  strokeDasharray: "5 5",
                  stroke: "#e0e0e0",
                },
                "& .MuiChartsAxis-tick": {
                  display: "none",
                },
              }}
            />
          </Box>
        </Box>
      </Box> */}
    </>
  );
};

export default LineGraph;
